// Backtest list page — heading "Backtests N pending · M running · K done",
// + New Backtest button. Mirrors grid-list-page.tsx structure.
import { useState } from "react";
import { useBacktests } from "@/hooks/use-backtests";
import BacktestCard from "@/components/backtest/backtest-card";
import CreateBacktestModal from "@/components/backtest/create-backtest-modal";

export default function BacktestListPage() {
  const { data: backtests, isLoading, error } = useBacktests();
  const [showCreate, setShowCreate] = useState(false);

  const list = backtests ?? [];
  const pending = list.filter((b) => b.status === "pending").length;
  const running = list.filter((b) => b.status === "running").length;
  const done = list.filter((b) => b.status === "done").length;

  return (
    <div>
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <h2 className="text-sm font-semibold text-text">
          Backtests{" "}
          <span className="text-muted font-normal text-xs">
            {pending} pending · {running} running · {done} done
          </span>
        </h2>
        <button
          className="inline-flex items-center h-7 px-3 text-xs font-medium rounded border border-accent/50 text-accent bg-accent/10 hover:bg-accent/20 transition-colors"
          onClick={() => setShowCreate(true)}
        >
          + New Backtest
        </button>
      </div>

      {isLoading && (
        <div className="text-muted text-sm text-center py-8">Loading backtests…</div>
      )}
      {error && (
        <div className="text-danger text-sm text-center py-4">
          Failed to load backtests: {(error as Error).message}
        </div>
      )}
      {!isLoading && list.length === 0 && (
        <div className="text-muted text-sm text-center py-8">No backtests yet</div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {list.map((bt) => (
          <BacktestCard key={bt.id} bt={bt} />
        ))}
      </div>

      {showCreate && <CreateBacktestModal onClose={() => setShowCreate(false)} />}
    </div>
  );
}
